<nz-modal [(nzVisible)]="isVisible" [nzTitle]="null" [nzContent]="modalContent" [nzFooter]="null" [nzClosable]="false"
  [nzWidth]="widthWindow()">
  <ng-template #modalContent>

    <nz-spin [nzSpinning]="isSpinning" style="z-index: 9999;">

      <div nz-row class="mb-3">
        <div nz-col nzSpan="20">
          <h1 class="title-model text-left sub-header-font-size">{{'G0000.G0021' | translate}} 2561</h1>
        </div>
        <div nz-col nzSpan="4" class="close-icon text-right">
          <i (click)="close(false)" nz-icon nzType="close" nzTheme="outline"></i>
        </div>
      </div>

      <!-- <nz-form-control>
      <div nz-row>
        <nz-table #firstTable [nzData]="dataFirstTable" nz-col nzLg="24" nzXl="24" [nzPageSize]="5">
          <thead>
            <tr class="data-table-thead">
              <th [nzWidth]="'10%'" [nzAlign]="'left'">{{'G0000.G0009' | translate}}</th>
              <th [nzWidth]="'78%'" [nzAlign]="'left'">{{'G0000.G0010' | translate}}</th>
              <th [nzWidth]="'12%'" [nzAlign]="'center'">{{'G0000.G0013' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of dataFirstTable; let i = index" class="data-table-tbody">
              <td [nzAlign]="'left'">{{ data.code }}</td>
              <td [nzAlign]="'left'">{{ data.description }}</td>
              <td [nzAlign]="'center'">{{ addComma(data.total.toFixed(2)) }}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </nz-form-control> -->

      <nz-form-control>
        <div id="basicTable" nz-row>
          <!-- <nz-select class="body-font-size" nzShowSearch nzServerSearch nzPlaceHolder="{{'G0000.G0023' | translate}}"
            [(ngModel)]="searchValue" [nzShowArrow]="true" [nzFilterOption]="nzFilterOption"
            (nzOnSearch)="search($event)">
            <nz-option class="body-font-size" *ngFor="let o of listOfOption; let i = index" [nzLabel]="o.text" [nzValue]="o.value">
            </nz-option>
          </nz-select> -->

          <nz-input-group [nzSuffix]="suffixIconSearch">
            <input type="text" #searchText nz-input placeholder="{{'G0000.G0023' | translate}}" (keyup)="search(searchText.value)"/>
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <i nz-icon nzType="search"></i>
          </ng-template>

          <nz-table #basicTable nzSize="middle" [nzScroll]="{ y: '240px' }" [nzData]="listOfData" nz-col
            [nzPageSize]="500" nzXs="24" nzLg="24" nzXl="24" [nzShowPagination]="false">

            <thead>
              <tr class="data-table-thead sub-header-font-size">
                <th [nzWidth]="'10%'" [nzAlign]="'left'">{{'G0000.G0009' | translate}}</th>
                <th [nzWidth]="'45%'" [nzAlign]="'left'">{{'G0000.G0010' | translate}}</th>
                <th [nzWidth]="'15%'" [nzAlign]="'center'">{{'G0000.G0011' | translate}}</th>
                <th [nzWidth]="'15%'" [nzAlign]="'center'">{{'G0000.G0012' | translate}}</th>
                <th [nzWidth]="'15%'" [nzAlign]="'center'">{{'G0000.G0013' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of basicTable.data; let i = index" class="body-font-size">
                <td [nzAlign]="'left'">{{ data.healCode }}</td>
                <td [nzAlign]="'left'">{{ data.healDetail }}</td>
                <td [nzAlign]="'right'">
                  <!-- *ngIf="data.healCode != '1.1' && data.healCode != '2.1'"  [disabled]="data.healCode == '1.1' || data.healCode == '1.1.1'"  -->
                  <input id="input-expense-{{i}}" type='text' nz-input class="input-radius text-right body-font-size"
                    placeholder="xxxx.xx" [(ngModel)]="data.expense" mask="separator.2" thousandSeparator=","
                    (keyup)="keyCurrency($event, i, data.discount)" (blur)="keyCurrency($event, i, data.discount)"
                    [disabled]="haveBill || data.disabledMainCode" />
                </td>
                <td [nzAlign]="'right'">
                  <input id="input-expense-{{i}}" type='text' nz-input class="input-radius text-right body-font-size"
                    value="{{data.discount}}" disabled="true" />
                </td>
                <td [nzAlign]="'right'">
                  <input id="input-expense-{{i}}" type='text' nz-input class="input-radius text-right body-font-size"
                    placeholder="xxxx.xx" mask="separator.2" thousandSeparator="," [disabled]="data.disabledMainCode"
                    [(ngModel)]="data.afterDiscount" (blur)="checkDiscount($event, i)"
                    (keyup)="checkDiscount($event, i)" />
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </nz-form-control>
      <div nz-row>
        <div nz-col nzSpan="12" class="pr-1">
          <div class="btn-wrapper" style="text-align: right;">
            <div class="btn-styles btn-blue text-center">
              <div class="txt">
                <button (click)="close(true)" type="button">{{'G0000.G0020' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div nz-col nzSpan="12" class="pl-1">
          <div class="btn-wrapper" style="text-align: left;">
            <div id="btn-reset" (click)="resetValue()" class="btn-styles btn-gray text-center">
              <div class="txt">
                <button type="button">{{'F0000.F0018' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </nz-spin>
  </ng-template>
  </nz-modal>